module.exports = __webpack_public_path__ + "static/media/NikoLogo.e4a85a16.svg";